<template>
  <el-config-provider :locale="locale_t">
    <DesktopLayout v-if="layout === 'desktop'" />
    <MobileLayout v-if="layout === 'mobile'" />
    <!-- <MobileLayout v-if="layout === 'mobile'" /> -->
    <AuthLayout v-if="layout === 'auth'" />
    <EmptyLayout v-if="layout === 'empty'" />
  </el-config-provider>
</template>

<script>
import MobileDetect from "mobile-detect";
import DesktopLayout from "@/layouts/DesktopLayout";
import MobileLayout from "@/layouts/MobileLayout";
import EmptyLayout from "./layouts/EmptyLayout.vue";
import AuthLayout from "@/layouts/AuthLayout";
import Korean from "element-plus/es/locale/lang/ko";
import English from "element-plus/es/locale/lang/en";
import Chinese from "element-plus/es/locale/lang/zh-cn";
import Vietnames from "element-plus/es/locale/lang/vi";

const locales = {
  ko: Korean,
  zh: Chinese,
  vi: Vietnames,
  en: English,
};

const md = new MobileDetect(window.navigator.userAgent);
const layoutType = md.mobile() ? "mobile" : "desktop";
const isAuth = window.location.pathname.includes("auth");

if (layoutType === "mobile") {
  import("@/assets/scss/mobile/_645.scss");
  import("@/assets/scss/mobile/_minigame.scss");
  // import('@/assets/scss/desktop/index.scss');
  import("@/assets/css/dhb_mobile/css/common@mobile.css");
  import("@/assets/css/dhb_mobile/css/content@mobile.css");
  import("@/assets/css/dhb_mobile/css/default@mobile.css");
  import("@/assets/css/dhb_mobile/css/layout@mobile.css");
  import("@/assets/css/dhb_mobile/css/lotto720@mobile.css");
  import("@/assets/css/dhb_mobile/css/main@mobile.css");
  import("@/assets/css/dhb_mobile/css/al720@mobile.css");
  import("@/assets/css/dhb_mobile/css/al720@mobile5152.css");
} else {
  import("@/assets/scss/desktop/index.scss");
  import("@/assets/css/dhb/app.css");
  import("@/assets/css/dhb/common.css");
  import("@/assets/css/dhb/layout.css");
  import("@/assets/css/dhb/main.css");
  import("@/assets/css/dhb/al720.css");
  import("@/assets/css/dhb/contents.css");
  import("@/assets/css/dhb/jquery-ui-1.8.17.custom.css");
}

export default {
  components: {
    DesktopLayout,
    MobileLayout,
    AuthLayout,
    EmptyLayout,
  },
  data() {
    return {
      layout: isAuth
        ? "auth"
        : window.location.pathname.includes("TotalGame/history")
        ? "empty"
        : layoutType,
      locale_t: locales[this.$store.state.locale],
    };
  },
  mounted() {
    this.$axios.get("/web/config/domain").then((res) => {
      if (res) {
        this.$i18n.locale = res.data.idm_locale;
        this.config = res.data;
        this.$store.dispatch("setDomainInfo", res.data);
        this.$store.dispatch("setLocale", res.data.idm_locale);
      }
    });
  },
  watch: {
    $route(to) {
      this.layout =
        to.meta.layout === "auth"
          ? "auth"
          : window.location.pathname.includes("TotalGame/history")
          ? "empty"
          : layoutType;
    },
  },
};
</script>
